import * as Yup from 'yup';
import { Endpoints } from '@/api/ApiEndpoints';

const validationSchema = Yup.object().shape({
	title: Yup.string().required().label('Title'),
	description: Yup.string().required().label('Description'),
	category: Yup.string().required().oneOf(['Daily', 'Longterm']).label('Category'),
	type: Yup.string().required().label('Mission Type'),
	targetValue: Yup.string().nullable().label('Target Value'),
	requiredCount: Yup.number().nullable().label('Required Count'),
	rewardCoins: Yup.number().required().label('Reward Coins'),
	isProgressive: Yup.boolean().oneOf([true, false]).label('Is Progressive'),
	progressionTiersJson: Yup.string().nullable().label('Progression Tiers'),
	isActive: Yup.boolean().oneOf([true, false]).label('Is Active')
});

const Inputs = [
	{
		name: 'title',
		label: 'Τίτλος',
		type: 'text',
		value: 'single',
		valueAttr: 'title',
	},
	{
		name: 'description',
		label: 'Περιγραφή',
		type: 'textarea',
		value: 'single',
		valueAttr: 'description',
	},
	{
		name: 'category',
		label: 'Τύπος',
		type: 'selectCustom',
		value: 'single',
		valueAttr: 'category',
		customOptions: () => [
			{ id: 'Daily', name: 'Daily' },
			{ id: 'Longterm', name: 'Longterm' },
		],
		isDisabled: (isUpdate) => isUpdate,
		
		required: true,
	},
	{
		name: 'type',
		label: 'Τύπος Mission',
		type: 'selectCustom',
		value: 'single',
		valueAttr: 'type',
		customOptions: () => [
			{ id: 'PlaceAnyBet', name: 'Παίξε οποιδήποτε στοίχημα' },
			{ id: 'PlaceBetOnSpecificGame', name: 'Παίξε ένα στοίχημα σε συγκεκριμένο παιχνίδι' },
			{ id: 'PlaceBetWithMinOdd', name: 'Παίξε ένα minimum απόδοση' },
			{ id: 'PlaceMarketType', name: 'Παίξε μια αγορά' },
			{ id: 'PlaceMarketItemType', name: 'Παίξε ένα συγκεκριμένο σημείο' },
			{ id: 'FollowUsers', name: 'Ακολούθα αλλούς χρήστες' },
			{ id: 'WinBets', name: 'Κέρδισε παιχνίδια' },
			{ id: 'DailyAppVisit', name: 'Επισκέψου το app κάθε μέρα' }
		],
		required: true,
		isDisabled: (isUpdate) => isUpdate,
		onChange: (localValues, event) => {
			localValues['targetValue'] = "";
		},
	},

	{
		name: 'targetValue',
		label: 'Παιχνίδι',
		type: 'select',
		value: 'single',
		valueAttr: 'targetValue',
		isPicker: true,
		hideInput: true,
		required: false,
		hasDisplayConditions: true,
		displayCondition: (values) => {
			return values.type === 'PlaceBetOnSpecificGame'
		}
	},
	{
		name: 'targetValue',
		label: 'Min Απόδοση',
		type: 'text',
		value: 'single',
		valueAttr: 'targetValue',
		required: false,
		hasDisplayConditions: true,
		displayCondition: (values) => {
			return values.type === 'PlaceBetWithMinOdd'
		}
	},
	{
		name: 'targetValue',
		label: 'Αγορές',
		type: 'selectCustom',
		value: 'single',
		valueAttr: 'targetValue',
		customOptions: () => [
			{ id: '1', name: 'Οποιαδήποτε Αγορά Τελίκό Αποτέλεσμα (1,x,2)' },
			{ id: '4,5,26,31', name: 'Οποιαδήποτε Αγορά Over/Under' },
			{ id: '14', name: 'Οποιαδήποτε Αγορά GG/NG' }, 
		],
		required: true, 
		hasDisplayConditions: true,
		displayCondition: (values) => {
			return values.type === 'PlaceMarketType'
		}
	},
	{
		name: 'marketTargetShortcut',
		label: 'Σημείο',
		type: 'selectCustomFromJson',
		value: 'single',
		valueAttr: 'marketTargetShortcut',
		valueFrom: 'targetValue',
		required: false,
		customOptions: () => [
			{ id: 'result_1', name: '1' },
			{ id: 'result_x', name: 'x' },
			{ id: 'result_2', name: '2' },

			{ id: 'ou_0_5_over', name: 'Over 0.5' },
			{ id: 'ou_0_5_under', name: 'Under 0.5' },
			{ id: 'ou_1_5_over', name: 'Over 1.5' },
			{ id: 'ou_1_5_under', name: 'Under 1.5' },
			{ id: 'ou_2_5_over', name: 'Over 2.5' },
			{ id: 'ou_2_5_under', name: 'Under 2.5' },
			{ id: 'ou_3_5_over', name: 'Over 3.5' },
			{ id: 'ou_3_5_under', name: 'Under 3.5' },
			{ id: 'ou_4_5_over', name: 'Over 4.5' },
			{ id: 'ou_5_5_under', name: 'Under 5.5' },

			{ id: 'ggng_yes', name: 'GG' },
			{ id: 'ggng_no', name: 'NG' },

			{ id: 'ggng_yes', name: 'GG' },
			{ id: 'ggng_no', name: 'NG' },
		],
		shortCutMapToReceive:
		{
			'7|Over|0.5': 'ou_0_5_over',
			'7|Under|0.5': 'ou_0_5_under',
			'7|Over|1.5': 'ou_1_5_over',
			'7|Under|1.5': 'ou_1_5_under',
			'7|Over|2.5': 'ou_2_5_over',
			'7|Under|2.5': 'ou_2_5_under',
			'7|Over|3.5': 'ou_3_5_over',
			'7|Under|3.5': 'ou_3_5_under',
			'7|Over|4.5': 'ou_4_5_over',
			'7|Under|5.5': 'ou_5_5_under',
			'14|Yes|null': 'ggng_yes',
			'14|No|null': 'ggng_no',
			'1|1|null': 'result_1',
			'1|x|null': 'result_x',
			'1|2|null': 'result_2',
			'7|null|null': 'ou_any',
			'14|null|null': 'ggng_any',
			'1|null|null': 'result_any',
		},
		
		lookupKey: (parsedJson) => {
			const marketId = parsedJson.MarketId;
			const oddLabel = parsedJson.OddLabel ?? 'null';
			const marketDescription = parsedJson.MarketDescription ?? 'null';
			return `${marketId}|${oddLabel}|${marketDescription}`;
		},
		hasDisplayConditions: true,
		displayCondition: (values) => {

			return values.type === 'PlaceMarketItemType'
		}
	},
	{
		name: 'isProgressive',
		label: 'Έχει Levels',
		type: 'checkbox',
		value: 'single',
		valueAttr: 'isProgressive',
		hasDisplayConditions: true,
		displayCondition: (values) => values.category === 'Longterm',
		defaultValue:() =>{
			return false;
		}
	},
	
	{
		name: 'requiredCount',
		label: 'Αριθμός που χρειάζεται για να κερδίσει το mission (π.χ παίξε 3 στοιχήματα)',
		type: 'text',
		value: 'single',
		valueAttr: 'requiredCount',
		required: false,
		hasDisplayConditions: true,
		displayCondition: (values) => !values.isProgressive,
	},
	
	
	{
		name: 'progressionTiersJson',
		label: 'Levels',
		type: 'chipsNumberArray',
		value: 'single',
		valueAttr: 'progressionTiersJson',
		placeholder: "Προσθέστε ένα level και πατήστε enter",
		required: false,
		hasDisplayConditions: true,
		displayCondition: (values) => values.isProgressive === true,
		/*transformToSend: (value) => {
			if (Array.isArray(value)) {
			const sanitized = value.filter((val) => typeof val === 'number' && !isNaN(val));
			return JSON.stringify(sanitized);
			} else if (typeof value === 'string') {
			return value;
			}
			return JSON.stringify([]);
		}*/
			
	},
	{
		name: 'rewardCoins',
		label: 'Πόσα κέρματα θα κερδίσει',
		type: 'text',
		value: 'single',
		valueAttr: 'rewardCoins',
		required: true,
	},
	{
		name: 'isRepeatable',
		label: 'Is Repeatable',
		type: 'checkbox',
		value: 'single',
		valueAttr: 'isRepeatable',
		hasDisplayConditions: true,
		displayCondition: (values) => values.Category == 'Daily',
		defaultValue:() =>{
			return false;
		}
	},
	{
		name: 'startDate',
		label: 'Start Date',
		type: 'date',
		value: 'single',
		valueAttr: 'startDate',
		
	},
	{
		name: 'endDate',
		label: 'End Date',
		type: 'date',
		value: 'single',
		valueAttr: 'endDate',
		hasDisplayConditions: true,
		displayCondition: (values) => values.isRepeatable == false && values.isProgressive == false,
		
	},
	{
		name: 'files',
		label: 'Image',
		type: 'image',
		value: 'single',
		valueAttr: 'imagePath',
		onChange: (localValues, event) => {
			localValues['files'] = event.target.files[0];
			localValues['imagePath'] = URL.createObjectURL(event.target.files[0]);
		},
		clearImage: (localValues) => {
			(<HTMLInputElement>document.getElementById("files")).value = "";
			localValues['files'] = '';
			localValues['imagePath'] = '';
		},
		transform: (path) => {
			if (path) {
				if (path.includes('blob')) {
					return path;
				}
				return process.env.VUE_APP_ASSETS_URL + '/' + path;
			}
			return path;
		},
		generateAction: {
			label: 'Generate AI Cover',
			visibleWhen: (values: any) => values.type === 'PlaceBetOnSpecificGame' && values.targetValue,
			endpoint: Endpoints.GENERATE_MATCH_COVER,
			getParam: (values: any) => values.targetValue,
			resultKey: 'imageUrl',
		},
	},
	{
		name: 'imagePath',
		label: '',
		type: 'hidden',
		value: 'single',
		valueAttr: 'imagePath',
		format: (path) => {
			return path;
		}
	},
	{
		name: 'isActive',
		label: 'Is Active',
		type: 'checkbox',
		value: 'single',
		valueAttr: 'isActive',
		defaultValue:() =>{
			return true;
		}
	},
];

export { Inputs, validationSchema };
